angular.module('wbComponents').directive 'spinnerCircle', ->
  restrict: 'E'
  replace: true
  template: """
<div class="spinner-circle">
  <div class="spinner-circle-container container1">
    <div class="circle1"></div>
    <div class="circle2"></div>
    <div class="circle3"></div>
    <div class="circle4"></div>
  </div>
  <div class="spinner-circle-container container2">
    <div class="circle1"></div>
    <div class="circle2"></div>
    <div class="circle3"></div>
    <div class="circle4"></div>
  </div>
  <div class="spinner-circle-container container3">
    <div class="circle1"></div>
    <div class="circle2"></div>
    <div class="circle3"></div>
    <div class="circle4"></div>
  </div>
</div>
  """

angular.module('wbComponents').directive 'spinnerFlat', ->
  restrict: 'E'
  replace: true
  template: """
<div class="spinner-flat">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
  """


angular.module('wbComponents').directive 'spinnerCircleLine', ->
  restrict: 'E'
  replace: true
  template: """
<div class="position-spinner">
  <svg class="spinner spinner--circle" viewbox="0 0 66 66">
    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
  """